import { render, staticRenderFns } from "./CRadioGroup.vue?vue&type=template&id=6c85fab1&scoped=true&"
import script from "./CRadioGroup.vue?vue&type=script&lang=ts&"
export * from "./CRadioGroup.vue?vue&type=script&lang=ts&"
import style0 from "./CRadioGroup.vue?vue&type=style&index=0&id=6c85fab1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c85fab1",
  null
  
)

export default component.exports